unit U_Model;

{ -------------------------------------------------------------------------------
  Plain data models used to map JSON payloads returned by the backend.

  Design choices:
  - Public fields (instead of properties) keep mapping straightforward.
  - Classes are simple containers; no behavior is implemented here.
  ------------------------------------------------------------------------------- }

interface

uses JS;

type
  // Generic HATEOAS-style link object as commonly found in REST responses.
  TLink = class
  public
    href: string;
    &type: string;
    rel: string;
  end;

  // Aggregated statistics displayed in the recap view.

  TStats = class
  public
    SoldeHeureJour: Double;
    SemainePrevu: Double;
    SemaineRealise: Double;
    SemaineSolde: Double;
    MoisEncours: Double;
    AnneeEncours: Double;
    VacanceConvenu: Double;
    VacanceSoldeTMois1: Double;
    VacanceRealiseConvenues: Double;
    SoldeVacanceDispo: Double;
  end;

  // Employee / user information ("ressource") used throughout the UI.

  TRessource = class
  public
    ID: Integer;
    Nom: string;
    Prenom: string;
    SysDate: string;
    SysUtil: string;
    SysPoste: string;
    CodePersonnel: string;
    Num: Integer;
    Humaine: Integer;
  end;

  // One time entry (presence/pause) coming from or sent to the API.
  // Note: Date fields use the project-wide date type aliases (see other units).

  TPresence = class
  public
    ID: Integer;
    RessourceId: Integer;
    TypeSaisieId: Integer;
    AffectationId: Integer;
    DateSaisie: TDAte;
    HeureDebut: TTime;
    DateHeureSaisie: TDateTime;
    DateFin: TDAte;
    HeureFin: TTime;
    DateHeureFin: TDateTime;
  end;

  // Pagination / metadata wrapper for list endpoints.

  TMeta = class
  public
    curr_page: string;
  end;

  // Example container for list responses: meta + data array.

  TRootObject = class
  public
    meta: TMeta;
    data: TArray<TRessource>;
  end;

  // Motif d'absence (loaded from server lookup)
  TMotifAbsence = class
  public
    ID: Integer;
    Libelle: string;
  end;

  // Type de période pour la demande
  TPeriodeType = (ptJournee, ptMatin, ptApresMidi, ptPeriodeLibre);

  // Demande de vacances / absence
  TDemandeVacance = class
  public
    ID: Integer;
    RessourceId: Integer;
    DateDebut: TDAte;
    DateFin: TDAte;
    HeureDebut: TTime;
    HeureFin: TTime;
    MotifId: Integer;
    MotifLibelle: string;
    Periode: string; // 'journee', 'matin', 'apresmidi', 'libre'
    Decision: JSValue; // 1=validé, 0=en attente, null=refusé
  end;

implementation

end.
